export class FileConfig {
  required: boolean;
  filters: { extension: string[]; documentTypeId?: string[]; fileMaxAgeDays?: number };
  optional: boolean;
  multiple: boolean;
  attachmentUploadSource: string;
  attachmentSourceEntities: string[];
  attachmentAnonymise: boolean;
  saveBackToDataSource: boolean;

  constructor(
    required: boolean,
    filters: { extension: string[]; documentTypeId?: string[]; fileMaxAgeDays?: number },
    optional?: boolean,
    multiple?: boolean,
    attachmentUploadSource?: string,
    attachmentSourceEntities?: string[],
    attachmentAnonymise?: boolean,
    saveBackToDataSource?: boolean
  ) {
    this.required = required;
    this.filters = filters;
    this.optional = optional ?? false;
    this.multiple = multiple ?? false;
    this.attachmentUploadSource = attachmentUploadSource;
    this.attachmentSourceEntities = attachmentSourceEntities;
    this.attachmentAnonymise = attachmentAnonymise ?? false;
    this.saveBackToDataSource = saveBackToDataSource ?? true;
  }

  static clone(config: FileConfig): FileConfig {
    return new FileConfig(
      config.required,
      {
        extension: [...config.filters.extension],
        documentTypeId: config.filters.documentTypeId ? [...config.filters.documentTypeId] : undefined,
        fileMaxAgeDays: config.filters.fileMaxAgeDays,
      },
      config.optional,
      config.multiple,
      config.attachmentUploadSource,
      config.attachmentSourceEntities ? [...config.attachmentSourceEntities] : undefined,
      config.attachmentAnonymise ?? false,
      config.saveBackToDataSource ?? true,
    );
  }
}
